/* import __COLOCATED_TEMPLATE__ from './freelancer-earnings-calculator-button.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

/**
 * A component which renders a calculate potential freelancer earnings button.
 */
 class FreelancerEarningsCalculatorButton extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      'SH-c-freelancer-earnings-calculator-button'
    );
  }
}

export default FreelancerEarningsCalculatorButton;
